"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get GenericIdParams () {
        return GenericIdParams;
    },
    get GenericJobIdResponse () {
        return GenericJobIdResponse;
    },
    get GenericNullResponse () {
        return GenericNullResponse;
    },
    get GenericSuccessResponse () {
        return GenericSuccessResponse;
    },
    get GenericTaskIdResponse () {
        return GenericTaskIdResponse;
    }
});
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const GenericSuccessResponse = _zod.z.object({
    message: _zod.z.string()
});
const GenericIdParams = _zod.z.object({
    id: _utilsisomorphic.transformObjectId
});
const GenericNullResponse = _zod.z.null();
const GenericJobIdResponse = _zod.z.object({
    jobId: _utilsisomorphic.transformObjectId
});
const GenericTaskIdResponse = _zod.z.object({
    taskId: _zod.z.string()
});
